export const numberFormat = (n, c) => {
  const digits = typeof c === 'number' ? c : 2
  return (Number(n) || 0).toLocaleString(undefined, {
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  })
}
